import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import CardContainer from 'components/common/CardContainer'
import theme from 'theme'
import CardList from 'components/common/CardList'
import Button from 'components/common/Button'
import Text from 'components/common/Text'

function CardLink({ title, buttonLabel, buttonType, to, disabled, ...rest }) {
  return (
    <CardContainer
      css={{
        borderRadius: theme.borderRadius[0],
        backgroundColor: theme.colors.white[0],
        textAlign: 'center'
      }}
      data-testid="dashboard-card"
      {...rest}
      showHoverEffect={false}
    >
      <Text as="h4">{title}</Text>
      <div css={{ textAlign: 'center' }}>
        <Button
          as={Link}
          css={{
            justifyContent: 'center',
            width: '100%',
            maxWidth: theme.space[9]
          }}
          disabled={disabled}
          to={to}
          {...buttonType}
        >
          {buttonLabel}
        </Button>
      </div>
    </CardContainer>
  )
}

CardLink.propTypes = {
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonType: PropTypes.object,
  to: PropTypes.string,
  disabled: PropTypes.bool
}

const ExperimentationLinks = ({ hasClients, isFreeEdition }) => {
  return (
    <CardList>
      <CardLink
        buttonLabel="Create Scenario"
        buttonType={{
          creative: true
        }}
        disabled={!hasClients}
        title="Link your attacks together"
        to="/scenarios/new"
      />
      <CardLink
        buttonLabel="View Recommended Scenarios"
        buttonType={{
          secondary: true
        }}
        title={
          isFreeEdition
            ? 'Not sure where to start?'
            : 'Want to recreate a failure?'
        }
        to="/scenarios/recommended"
      />
      <CardLink
        buttonLabel="Create Attack"
        buttonType={{
          creative: true
        }}
        disabled={!hasClients}
        title="Quickly run an attack"
        to="/attacks/new"
      />
    </CardList>
  )
}

export default ExperimentationLinks

ExperimentationLinks.propTypes = {
  hasClients: PropTypes.bool,
  isFreeEdition: PropTypes.bool
}
